/**
 * Taste Profile bottom sections — bottle marquee + page FAQ (scoped).
 * Used on Father's Day page; selectors limited to [data-section="father-day-tp-bottom"].
 */
(function () {
  var SECTION = '[data-section="father-day-tp-bottom"]';
  var AUTO_SCROLL_PX_PER_SEC = 42;

  function initFaqGroup(root, itemSelector, questionSelector, answerSelector, iconSelector, openClass) {
    var items = root.querySelectorAll(itemSelector);
    items.forEach(function (item) {
      var btn = item.querySelector(questionSelector);
      var answer = item.querySelector(answerSelector);
      if (!btn || !answer) return;
      var icon = btn.querySelector(iconSelector);
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains(openClass);
        item.classList.toggle(openClass, !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
        if (isOpen) {
          answer.setAttribute('hidden', '');
          if (icon) icon.textContent = '+';
        } else {
          answer.removeAttribute('hidden');
          if (icon) icon.textContent = '−';
        }
      });
    });
  }

  function initBottleRail(section) {
    var marquee = section.querySelector('[data-tp-whats-inside-marquee]');
    var track = section.querySelector('[data-tp-marquee-track]');
    if (!marquee || !track) return;
    if (track.getAttribute('data-tp-rail-initialized') === 'true') return;
    if (marquee.offsetWidth === 0 || track.offsetWidth === 0) return;

    var originals = Array.prototype.slice.call(track.querySelectorAll('.tp-whats-inside__item'));
    if (!originals.length) return;

    track.innerHTML = '';
    originals.forEach(function (item) {
      track.appendChild(item.cloneNode(true));
    });
    originals.forEach(function (item) {
      var copy = item.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      track.appendChild(copy);
    });

    var loopWidth = track.scrollWidth / 2;
    if (!loopWidth) return;
    track.setAttribute('data-tp-rail-initialized', 'true');

    var offset = 0;
    var paused = false;
    var dragging = false;
    var dragStartX = 0;
    var dragStartOffset = 0;
    var pointerId = null;
    var lastTs = 0;

    function normalize(value) {
      var v = value % loopWidth;
      if (v < 0) v += loopWidth;
      return v;
    }

    function applyTransform() {
      track.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
    }

    function tick(ts) {
      if (!lastTs) lastTs = ts;
      var dt = ts - lastTs;
      lastTs = ts;
      if (!paused && !dragging) {
        offset = normalize(offset + ((AUTO_SCROLL_PX_PER_SEC * dt) / 1000));
        applyTransform();
      }
      requestAnimationFrame(tick);
    }

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      pointerId = e.pointerId;
      dragging = true;
      paused = true;
      dragStartX = e.clientX;
      dragStartOffset = offset;
      track.classList.add('is-dragging');
      if (track.setPointerCapture && pointerId != null) {
        try { track.setPointerCapture(pointerId); } catch (err) {}
      }
    }

    function onPointerMove(e) {
      if (!dragging || (pointerId != null && e.pointerId !== pointerId)) return;
      var delta = e.clientX - dragStartX;
      if (e.cancelable) e.preventDefault();
      offset = normalize(dragStartOffset - delta);
      applyTransform();
    }

    function onPointerUp(e) {
      if (!dragging || (pointerId != null && e.pointerId !== pointerId)) return;
      dragging = false;
      pointerId = null;
      track.classList.remove('is-dragging');
      if (track.releasePointerCapture && e.pointerId != null) {
        try { track.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      paused = marquee.matches(':hover');
    }

    track.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove, { passive: false });
    window.addEventListener('pointerup', onPointerUp);
    window.addEventListener('pointercancel', onPointerUp);
    marquee.addEventListener('mouseenter', function () { if (!dragging) paused = true; });
    marquee.addEventListener('mouseleave', function () { if (!dragging) paused = false; });

    applyTransform();
    requestAnimationFrame(tick);

    window.addEventListener('resize', function () {
      var nextLoopWidth = track.scrollWidth / 2;
      if (!nextLoopWidth) return;
      loopWidth = nextLoopWidth;
      offset = normalize(offset);
      applyTransform();
    });
  }

  function boot() {
    var section = document.querySelector(SECTION);
    if (!section || section.dataset.tpBottomBooted) return;
    section.dataset.tpBottomBooted = '1';

    initBottleRail(section);
    initFaqGroup(
      section,
      '.tp-faq .tp-faq__item',
      '.tp-faq__question',
      '.tp-faq__answer',
      '.tp-faq__icon',
      'tp-faq__item--open'
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      requestAnimationFrame(boot);
    });
  } else {
    requestAnimationFrame(boot);
  }
})();
